import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';

const signContainerHeight = 4;

const styles = {
  password: css`
    label: password;
    display: flex;
    flex-direction: row;
    align-items: end;
    justify-content: space-between;
  `,

  showHideButton: (isDisabled?: boolean): string => css`
    label: password__showHideButton;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    height: ${signContainerHeight}rem;
    margin-left: ${spacing.XXS};
    padding-top: ${spacing.XXXS};
    padding-bottom: ${spacing.XXXS};
    color: ${colours.font.ASSISTIVE};
    background-color: ${colours.background.OFF_WHITE};
    border: 1px solid ${colours.border.LIGHT_GRAY};
    outline: none;
    cursor: pointer;

    ${isDisabled &&
    css`
      color: ${colours.font.DISABLED};
      background: ${colours.field.DISABLED};
      cursor: default;
    `}
  `,

  icon: css`
    label: eye__icon;
    margin: auto;
  `,
};

export default styles;
